import {FC} from "react";
import styled from "@emotion/styled/macro";
import {NavLink, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {ISubNavLink} from "modules/types";
import {isLoggedIn} from "modules/selectors";
import {breakpoints} from "assets/theme";

const CollapseLinks = styled.div`
	position: absolute;
	top: 100%;
	left: -4px;
	z-index: 100;
	opacity: 0;
	transition: all 0.2s ease-out;
	visibility: hidden;
	overflow: visible;
	box-shadow: 0 1px 2px rgba(28, 28, 30, 0.1), 0 8px 16px rgba(28, 28, 30, 0.2);
`;

const Link = styled(NavLink)`
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: "Hind", sans-serif;
	font-weight: 600;
	font-size: 16px;
	line-height: 140%;
	text-transform: uppercase;
	padding: 10px;
	height: 100%;
	transition: all 0.3s;

	&.active,
	&:hover {
		color: ${({theme}) => theme.colorPalette.black};
		background: ${({theme}) => theme.colorPalette.white};
	}
`;

const LinkContainer = styled.div`
	display: none;
	position: relative;

	@media (min-width: ${breakpoints.medium}) {
		display: flex;
	}

	&:hover {
		${CollapseLinks} {
			visibility: visible;
			opacity: 1;
		}

		${Link} {
			color: ${({theme}) => theme.colorPalette.black};
			background: ${({theme}) => theme.colorPalette.white};
		}
	}
`;

const SubLink = styled(NavLink)`
	display: flex;
	align-items: center;
	font-family: "Hind", sans-serif;
	font-weight: 600;
	font-size: 16px;
	line-height: 140%;
	text-transform: uppercase;
	padding: 10px;
	color: ${({theme}) => theme.colorPalette.black};
	background: ${({theme}) => theme.colorPalette.white};
	min-height: 44px;
	white-space: nowrap;

	&:hover {
		background: #f6f6f6;
	}
`;

export const SubHeaderLink: FC<ISubNavLink> = ({urls, title, href, isPrivate, isEnabled}) => {
	const {t} = useTranslation();
	const isLogged = useSelector(isLoggedIn);
	const {search} = useLocation();
	const isHideLink = (!isLogged && isPrivate) || isEnabled === false;

	if (isHideLink) {
		return null;
	}

	return (
		<LinkContainer>
			<Link to={`${href}${search}`}>{t(title)}</Link>

			{urls && (
				<CollapseLinks>
					{urls.map(({title, href}) => (
						<SubLink key={href} to={`${href}${search}`}>
							{t(title)}
						</SubLink>
					))}
				</CollapseLinks>
			)}
		</LinkContainer>
	);
};
